import { render, staticRenderFns } from "./RgVideoPlayBackButton.vue?vue&type=template&id=2b4b5bf3&scoped=true&"
import script from "./RgVideoPlayBackButton.vue?vue&type=script&lang=js&"
export * from "./RgVideoPlayBackButton.vue?vue&type=script&lang=js&"
import style0 from "./RgVideoPlayBackButton.vue?vue&type=style&index=0&id=2b4b5bf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b5bf3",
  null
  
)

export default component.exports